<template>
  <div id="mySidenav" class="sidenav" v-show="sideBar">
    <div class="px-2" id="sidebar">
      <div class="filter-head mt-2 mb-4">
        <span class="filter-txt">Filter</span>
<!--        <button type="button" class="btn btn-light radius-20 float-right">zurücksetzen </button>-->
      </div>
      <div id="accordion" class="accordion-style mt-2">
        <div id="child1" class="mb-3 mt-2">
          <h5 class="mb-0 mtab">
            <a href="#" data-toggle="collapse"  data-target="#collapseErss" aria-expanded="true" class="text-capitalize">
              Status
            </a>
          </h5>
          <div class="collapse show" data-parent="#child1" id="collapseErss">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="customCheckah" name="example1" v-model="status.done" :true-value="'0'">
              <label class="custom-control-label custom-label" for="customCheckah">
                Erledigt
              </label>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="customCheckcb" name="example1" v-model="status.check" :true-value="'1'">
              <label class="custom-control-label custom-label" for="customCheckcb"> Prüfen</label>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="customCheckcb1" name="example1" v-model="status.open" :true-value="'2'">
              <label class="custom-control-label custom-label" for="customCheckcb1"> Offen</label>
            </div>
          </div>
        </div>

        <div id="child2" class="mb-3">
          <h5 class="mb-0 mtab">
            <a href="#" data-toggle="collapse" data-target="#collapseFre" aria-expanded="true">Typ</a>
          </h5>
          <div class="collapse show" data-parent="#child2" id="collapseFre">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="customCheckgp" v-model="mangelType">
              <label class="custom-control-label custom-label text-capitalize" for="customCheckgp">Mangel</label>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="customCheckng" v-model="restType">
              <label class="custom-control-label custom-label" for="customCheckng">Restleistung</label>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <h5 class="mb-0 mtab">
            <a href="#" data-toggle="collapse" data-target="#collapseFrev" aria-expanded="true">Ersteller</a>
          </h5>
          <div class="collapse show" data-parent="#child1" id="collapseFrev">
            <div class="custom-control custom-checkbox" v-for="user in projectUsers" v-if="user.firstname">
              <input type="checkbox" class="custom-control-input" :id="'user'+user.pduserid" v-model="users" :value="user"  name="example1">
              <label class="custom-control-label custom-label text-capitalize" :for="'user'+user.pduserid">
                {{ user.firstname }} {{ user.lastname }}
              </label>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <h5 class="mb-0 mtab">
            <a href="#" data-toggle="collapse" data-target="#collapseFrever" aria-expanded="true">Verantwortlicher</a>
          </h5>
          <div class="collapse show" data-parent="#child1" id="collapseFrever">
            <div class="custom-control custom-checkbox" v-for="user in projectUsers" v-if="user.firstname">
              <input type="checkbox" class="custom-control-input" :id="'user11'+user.pduserid" v-model="responsible" :value="user">
              <label class="custom-control-label custom-label text-capitalize" :for="'user11'+user.pduserid">
                {{ user.firstname }} {{ user.lastname }}
              </label>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <h5 class="mb-0 mtab">
            <a href="#" data-toggle="collapse" data-target="#gewerk" aria-expanded="true">Gewerk</a>
          </h5>
          <div class="collapse show" data-parent="#child1" id="gewerk">
            <div class="custom-control custom-checkbox" v-for="(trade , index) in services" >
              <input type="checkbox" class="custom-control-input" :id="'gewerk'+trade.servicenumber+index" v-model="trades" :value="trade">
              <label class="custom-control-label custom-label text-capitalize" :for="'gewerk'+trade.servicenumber+index">
                {{ trade.pdservicetitle.substring(0,50,) }} <span v-if="trade.company"> ( {{ trade.company }} ) </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import moment from "moment"
export default {
  props: ['sideBar'],
  data(){
    return {
      status:{
        done: null,
        check: null,
        open: null,
      },
      mangelType: null,
      restType: null,
      users: [],
      responsible: [],
      trades: [],
      filtersAry: [],
      runId: null,
      page: 1,
      orderQry: [
        {
          _explicitType: "com\\projectdocu\\OrderSettingVO",
          fieldname: 'runid',
          order : 'DESC',
        }
      ]
    }
  },

  mounted () {

  },
  methods: {

    getFilterParams () {
      this.filtersAry = [];
      let id = this.$route.params.id;
      let page = this.$parent.currentPage - 1;
      let searchQry = this.$parent.searchString;
      this.filtersAry = [id, 20, page, {
        _explicitType: "com\\projectdocu\\PredicateOperatorAndVO",
        operands: [] //this will have all filter options array
      }, this.orderQry];

      // filter by date...
      this.setFilterForFlawDate();

      if (this.checkObject(this.status)) {
        this.setFilterForFlawStatus();
      }

      if (searchQry.length > 1) {
        this.setSearchQueryParams(searchQry);
      }

      if (this.mangelType !== this.restType) {
        this.setFilterForType()
      }

      if (this.users.length > 0) {
        this.setFilterForProjectUsers();
      }

      if (this.responsible.length > 0) {
        this.setFilterForProjectResponsible();
      }

      if (this.trades.length > 0) {
        this.setFilterForTrades();
      }

    },

    //Set Filter Params For Project users
    setFilterForTrades () {
      let trades_filter = {
        _explicitType: "com\\projectdocu\\PredicateOperatorOrVO",
        operands: []
      }
      this.trades.forEach(trade => {
        let item = {
          fieldname: 'work',
          fieldvalue: `${trade.pdserviceid}-${trade.projectuserserviceid}`,
          _explicitType: "com\\projectdocu\\PredicateOperandLikeVO",
        }
        trades_filter.operands.push(item);
      })

      this.filtersAry[3].operands.push(trades_filter);
    },

    //Set Filter Params For Project users
    setFilterForProjectUsers () {

      let creator_filter = {
        _explicitType: "com\\projectdocu\\PredicateOperatorOrVO",
        operands: []
      }
      this.users.forEach(user => {
        let item = {
          fieldname: 'creator',
          fieldvalue: user.pduserid,
          _explicitType: "com\\projectdocu\\PredicateOperandEQVO",
        }
        creator_filter.operands.push(item);
      })

      this.filtersAry[3].operands.push(creator_filter);
    },

    //Set Filter Params For Project responsible
    setFilterForProjectResponsible () {
      let responsible_filter = {
        _explicitType: "com\\projectdocu\\PredicateOperatorOrVO",
        operands: []
      }
      this.responsible.forEach(user => {
        let item = {
          fieldname: 'responsibleuser',
          fieldvalue: user.pduserid,
          _explicitType: "com\\projectdocu\\PredicateOperandEQVO",
        }
        responsible_filter.operands.push(item);
      })

      this.filtersAry[3].operands.push(responsible_filter);
    },

    setFilterForFlawDate () {
      let dateFrom = moment(this.date_from, 'DD.MM.YYYY').format('YYYY-MM-DD');
      let dateTo = moment(this.date_to, 'DD.MM.YYYY').format('YYYY-MM-DD');
      let item = {
        fieldname: 'flawdate-day',
        _explicitType: "com\\projectdocu\\PredicateOperandBetweenVO",
        fieldvalueFrom: dateFrom+' 00:00:00',
        fieldvalueTo: dateTo +' 23:59:59',
      }
      this.filtersAry[3].operands.push(item);
    },

    //Set Filter Params For Status
    setFilterForFlawStatus () {
      let status = this.status
      let status_filter = {
        _explicitType: "com\\projectdocu\\PredicateOperatorOrVO",
        operands: []
      }
      for (const property in status) {
        let item = {};
        if (status[property] != null && status[property]) {
          item = {
            fieldname: 'status',
            fieldvalue: status[property],
            _explicitType: "com\\projectdocu\\PredicateOperandEQVO",
          }
          status_filter.operands.push(item);
        }
      }

      this.filtersAry[3].operands.push(status_filter);
    },

    //set filter params for search query
    setSearchQueryParams (search_qry) {
      let search_query = {
        _explicitType: "com\\projectdocu\\PredicateOperatorOrVO",
        operands: []
      }
      let title = {
        fieldname: 'flawname',
        fieldvalue: search_qry,
        _explicitType: "com\\projectdocu\\PredicateOperandLikeVO",

      };
      search_query.operands.push(title);

      this.filtersAry[3].operands.push(search_query);
    },

    //set filter params by flaw type
    setFilterForType () {
      let type = this.mangelType ? 1 : 2;
      let item = {
        fieldname: 'flawtype',
        fieldvalue: type,
        _explicitType: "com\\projectdocu\\PredicateOperandEQVO",
      }
      this.filtersAry[3].operands.push(item);
    },

    // main function for filter the flaws list run on change of each param
    async filterProjectFlaws () {
      await this.getFilterParams();
      await this.$parent.getTasks(this.filtersAry)
    },

    //check object is not fully empty
    checkObject (obj) {
      for (let key in obj) {
        if (obj[key] !== null && obj[key] !== "")
          return true;
      }
      return false;
    },
  },

  computed : {
    ...mapState({
      is_loading: state => state.constructionDiary.is_loading,
      date_from: state => state.tasks.dateFrom,
      date_to: state => state.tasks.dateTo,
      services: state => state.tasks.servicesWithCompanies,
      projectUsers: state => state.appSettings.projectUsers,
    }),
  },

  watch : {
    status: {
      handler(){
        this.$parent.currentPage = 1
        this.filterProjectFlaws()
      },
      deep: true
    },

    mangelType: function (){
      this.$parent.currentPage = 1
      this.filterProjectFlaws()
    },

    restType: function (){
      this.$parent.currentPage = 1
      this.filterProjectFlaws()
    },

    users: function (){
      this.$parent.currentPage = 1
      this.filterProjectFlaws()
    },

    responsible: function (){
      this.$parent.currentPage = 1
      this.filterProjectFlaws()
    },

    trades: function (){
      this.$parent.currentPage = 1
      this.filterProjectFlaws();
    },

    date_from: async function (){
      this.$parent.currentPage = 1
      await this.filterProjectFlaws();
    },

    date_to: async function (){
      this.$parent.currentPage = 1
     await this.filterProjectFlaws();
    },

    '$parent.currentPage': function (val){
        this.page = val;
        this.filterProjectFlaws();
    },
    '$parent.searchString': function (val){
        this.page = val;
        this.filterProjectFlaws();
    }
  }
}
</script>



<style scoped>
.accordion-style .custom-control-label {
  font-size: 13px
}
.sidenav {
  height: calc(100vh - 170px);
  width: 17%;
  position: absolute;
  left: 0 !important;
  z-index: 9999;
}
.accordion-style .custom-control-label::after {
  top: 6.5px !important;
  left: -22px !important;
}
.accordion-style .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #007bff;
  border: 0.5px solid #0055ff;
}
</style>



// WEBPACK FOOTER //
// src/components/tasks/TasksFilterNav.vue